import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { GetBrNavigationsResponse, SubMenu } from './appstate.models';
import { catchError, map, Observable } from 'rxjs';
import { AppstateService } from './appstate.service';

@Injectable()
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private appstateService: AppstateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.appstateService.getBrokerNavigations().pipe(
      map((navigationResponse: GetBrNavigationsResponse) => {
        const entitlementMenu: string = route.data['entitlementMenu'];
        const entitlementMenuArray: string[] = entitlementMenu.split(',');

        let isValidRoute = false;

        navigationResponse.data?.navigation?.menus.forEach((menu) => {
          // Loop through menu
          if (
            entitlementMenuArray.some(
              (entitlement) => entitlement === menu.entitlement,
            )
          ) {
            isValidRoute = true;
          }

          // Loop through l2 menu
          if (
            menu.subMenus?.some((subMenu: SubMenu) =>
              entitlementMenuArray.some(
                (entitlement) => entitlement === subMenu.entitlement,
              ),
            )
          ) {
            isValidRoute = true;
          }

          // Loop through l3 submenu items for Tools section
          menu.subMenus?.forEach((l3menu: SubMenu) => {
            if (
              l3menu.l3Menus?.some((l3SubMenu: SubMenu) =>
                entitlementMenuArray.some(
                  (entitlement) => entitlement === l3SubMenu.entitlement,
                ),
              )
            ) {
              isValidRoute = true;
            }
          });
        });

        // Check other entitlements
        navigationResponse.data?.navigation?.entitlements.forEach((menu) => {
          if (
            entitlementMenuArray.some((entitlement) => entitlement === menu)
          ) {
            isValidRoute = true;
          }
        });

        if (isValidRoute) {
          return true;
        }
        this.router.navigate(['secure/not-authorized'], {
          replaceUrl: true,
        });
        return false;
      }),
      catchError(() => {
        this.router.navigate(['secure/not-authorized'], {
          replaceUrl: true,
        });
        return [false];
      }),
    );
  }
}
